module.exports = __webpack_public_path__ + "img/1.2347eb57.png";